import { HttpError } from 'app/components/utils/http-error';

export enum EntityType {
  Deal = 'deal',
  Task = 'task'
}

export interface Plugins {
  id: number;
  name: string;
  description: string;
}

export const getPluginsList = async (entityType?: EntityType): Promise<Plugins[]> => {
  const searchParams = new URLSearchParams();
  if (entityType) {
    searchParams.append('entityType', entityType);
  }
  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/plugins?${searchParams.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (!response.ok) {
    return Promise.reject(
      new HttpError(`Failed to get plugins: ${response.statusText}`, response.status)
    );
  }
  return await response.json();
};
